import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { OnZoom } from '../../Document/_actions/DocumentActions';
import ZoomButton, { Props } from '../_components/ZoomButton';

const mapStateToProps = (store:Store, props:Props) => ({
	documentDPI: store.getIn(['create', 'document', 'dpi']),
	documentWidth: store.getIn(['create', 'document', 'width']),
	documentHeight: store.getIn(['create', 'document', 'height']),
	viewerWidth: store.getIn(['create', 'viewer','width']),
	viewerHeight: store.getIn(['create', 'viewer','height'])
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onZoom: (level:number, offsetX:number, offsetY:number) => dispatch(OnZoom(level, offsetX, offsetY))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ZoomButton);